'use strict'

import moment from 'moment'

export const umsValidateOrderDate = () => {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, elm, attrs, ctrl) {
      const format = 'DD.MM.YYYY'
      const max = moment().add(8, 'weeks').endOf('day')
      const min = moment().endOf('day')
      ctrl.$validators.date = (modelValue) => moment(modelValue, format).isValid()
      ctrl.$validators.umsDateMax = (modelValue) =>
        ctrl.$isEmpty(modelValue) ||
        (moment(modelValue, format).isValid() && moment(modelValue, format).endOf('day').isBefore(max))
      ctrl.$validators.umsDateMin = (modelValue) =>
        ctrl.$isEmpty(modelValue) ||
        (moment(modelValue, format).isValid() && moment(modelValue, format).endOf('day').isAfter(min))
    },
  }
}



// WEBPACK FOOTER //
// ./app/orders/directives/ums-validate-order-date.directive.js